import { useLocation, useNavigate } from 'react-router';
import { Link } from '#components/atoms/link/Link.tsx';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { PageCloser } from '#components/patterns/page-closer/PageCloser.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import type { NewKeyState } from '#screens/settings/api-keys/types.ts';
import { fromArray, Titled } from '#util/title.ts';
import { JoinKeyForm } from '../form/JoinKeyForm.tsx';

export function AddJoinKeyPage() {
  const navigate = useNavigate();
  const location = useLocation();

  function showToken(newKey: NewKeyState) {
    void navigate({ pathname: '/settings/join-keys', search: location.search }, { state: { newKey }, replace: true });
  }

  return (
    <Titled title={(title) => fromArray(['Add', title])}>
      <MainLayout
        header={
          <PageHeader
            title={
              <>
                <Link to="/settings/join-keys" className="a">
                  Host join keys
                </Link>
                {' / '}
                Add
              </>
            }
          >
            <PageCloser fallbackTo="/settings/join-keys" />
          </PageHeader>
        }
      >
        <JoinKeyForm id={null} onSuccess={showToken} />
      </MainLayout>
    </Titled>
  );
}
